<template>
  <LotsTableBase
    :additional_fields="additional_fields"
    :bidding_type="bidding_type"
    :custom-sort-slice="customSortSlice"
    :disable-open-offers-for-lot="disableOpenOffersForLot"
    :group="group"
    :in_creating="in_creating"
    :lots_headers="lots_headers"
    :tender="tender"/>
</template>

<script>
import LotsTableBase from 'components/tenders/tender page/tender tabs/tables/LotsTableBase.vue'
import lotsTableMixin from 'mixins/lotsTableMixin.js'

export default {
  name: 'LotsTabTable',
  components: {
    LotsTableBase
  },
  mixins: [lotsTableMixin]
}
</script>